import React from "react";
const SeperatorLine = () => {
  return <div className="separator-breadcrumb border-top"></div>;
};

export default SeperatorLine;
